// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__25TdW","footer":"ModalUpdate_footer__wJ2Qr"};